const EMAIL_LOCAL_PATTERN = '^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))';
const DOMAIN_PATTERN = '((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])';
const DOMAIN_ALTERNATIVE_PATTERN = '(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))';
const EMAIL_TEST = new RegExp(`${EMAIL_LOCAL_PATTERN}@${DOMAIN_PATTERN}|${DOMAIN_ALTERNATIVE_PATTERN}$`);

const validator = {
  email(email: string): { isValid: boolean; message?: string } {
    if (!email || !EMAIL_TEST.test(email)) {
      return {
        isValid: false,
        message: 'Please enter a valid email address.',
      };
    }
    if (email.length > 115) {
      return {
        isValid: false,
        message: 'Email address cannot exceed 115 characters.',
      };
    }

    return {
      isValid: true,
    };
  },
  httpUrl(url: string): { isValid: boolean } {
    const re = /^https?:\/\//;

    return {
      isValid: re.test(url),
    };
  },
  phoneNumber(number: string): { isValid: boolean; message?: string } {
    const re = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s.]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}$/;

    if (re.test(number)) {
      return {
        isValid: true,
      };
    } else {
      return {
        isValid: false,
        message: 'Enter a valid phone number.',
      };
    }
  },
  date(string: string): { isValid: boolean; message?: string } {
    const dateRegExp = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

    if (string) {
      if (string.match(dateRegExp)) {
        return {
          isValid: true,
        };
      }
    }
    return {
      isValid: false,
      message: 'Enter a valid date - MM/DD/YYYY',
    };
  },
  number(numberString: string): { isValid: boolean; message?: string } {
    const numberRegExp = /^[0-9]*$/;

    if (numberString) {
      if (numberString.match(numberRegExp)) {
        return {
          isValid: true,
        };
      }
    }
    return {
      isValid: false,
    };
  },
};

export default validator;
